import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormInput } from "../../common/FormInput";
import { FormTextarea } from "../../common/FormTextarea";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface StudentInfoSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  className?: string;
  showTitle?: boolean;
}

export const StudentInfoSection: React.FC<StudentInfoSectionProps> = ({
  formData,
  onChange,
  className,
  showTitle,
}) => {
  return (
    <CollapsibleFormSection
      title={
        showTitle === undefined || showTitle ? "Student information" : undefined
      }
      className={className}
    >
      <div className="form-row form-row--2-cols">
        <FormInput
          id="studentAge"
          name="studentAge"
          label="Age"
          value={formData.studentAge}
          onChange={onChange}
          width="half"
        />

        <FormInput
          id="yearLevel"
          name="yearLevel"
          label="Year level"
          value={formData.yearLevel}
          onChange={onChange}
          width="half"
        />
      </div>

      <FormTextarea
        id="strengths"
        name="strengths"
        label="Strengths and Interests"
        value={formData.strengths}
        onChange={onChange}
        rows={4}
      />
    </CollapsibleFormSection>
  );
};
